import { filterBy } from '../filtering/filter-expression.factory';
import { process } from '../array.operators';
import cloneDeep from 'lodash/cloneDeep';
import cloneDeepWith from 'lodash/cloneDeepWith';
import { toJS, comparer } from 'mobx';
export class InMemoryDataSource {
    constructor(data, idSelector, preprocessors = {}, { cloneCustomizer } = {}) {
        Object.defineProperty(this, "idSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "preprocessors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cached", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.clone = cloneCustomizer
            ? (value) => cloneDeepWith(value, cloneCustomizer)
            : cloneDeep;
        this.data = this.clone(toJS(data));
        this.idSelector = idSelector;
        this.preprocessors = preprocessors;
    }
    getData(state) {
        const { skip, take, sort, filter, group } = state;
        const sortedAndFiltered = this.cached && comparer.structural(this.cached.state, { sort, filter })
            ? this.cached.result
            : process(this.data, { sort, filter }, this.preprocessors);
        this.cached = {
            state: { sort, filter },
            result: sortedAndFiltered,
        };
        const { data } = process(sortedAndFiltered.data, { skip, take, group }, this.preprocessors);
        const { total } = sortedAndFiltered;
        return Promise.resolve({
            total,
            data: this.clone(data),
        });
    }
    addData(row, index) {
        if (index !== undefined) {
            this.data.splice(index, 0, this.clone(row));
        }
        else {
            this.data.push(this.clone(row));
        }
        this.cached = undefined;
        return Promise.resolve(this.clone(row));
    }
    async updateData(id, changes) {
        if (!this.idSelector) {
            throw 'missing idSelector';
        }
        const row = this.data.find(row => this.idSelector(row) === id);
        if (row) {
            Object.assign(row, changes);
            this.cached = undefined;
        }
        return Promise.resolve();
    }
    async removeData(id) {
        if (!this.idSelector) {
            throw 'missing idSelector';
        }
        const index = this.data.findIndex(row => this.idSelector(row) === id);
        if (index !== -1) {
            const row = this.data[index];
            this.data.splice(index, 1);
            this.cached = undefined;
            return Promise.resolve(row);
        }
    }
    getFilteredPersistentItems(filter) {
        const set = new Set(this.data);
        const inFilter = filterBy(this.data, filter, this.preprocessors);
        inFilter.forEach(dataItem => set.delete(dataItem));
        return this.clone(Array.from(set));
    }
}
//# sourceMappingURL=in-memory-data-source.js.map